import { mapToId, sortByCreatedAt } from '@witmetrics/utils/arrays';
import {
  useLeadProjects,
  useOrdersFromProjectIdArray,
} from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { Tab } from '@/components/TabsBlock';
import Section from '@/overlays/CaseOverlay/Section';
import SectionTitle from '@/overlays/CaseOverlay/SectionTitle';
import OrdersList from '@/components/OrdersList';
import EmptyMessage from '@/overlays/CaseOverlay/EmptyMessage';
import { classes } from './utils';

export type OrdersTabProps = {
  isFetchingData?: boolean;
  name: string;
  label: string;
};

export default function OrdersTab({
  isFetchingData,
  name,
  label,
}: OrdersTabProps) {
  const { activeLeadId } = useAppState();
  const projects = useLeadProjects(activeLeadId);
  const orders = useOrdersFromProjectIdArray(mapToId(projects));

  return (
    <Tab name={name} label={label}>
      <Section>
        <SectionTitle title="Orders" />
        {orders.length > 0 ? (
          <OrdersList
            isFetchingData={isFetchingData}
            className={classes.ordersList}
            orderIds={mapToId(sortByCreatedAt(orders))}
          />
        ) : (
          <EmptyMessage>No orders.</EmptyMessage>
        )}
      </Section>
    </Tab>
  );
}
